var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "100px",
    height: "100px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.64355,74.10547a8.00344,8.00344,0,0,1-7.17089-11.53711A112.28357,112.28357,0,0,1,68.29688,17.22363a7.99959,7.99959,0,1,1,8.54,13.5293A96.29849,96.29849,0,0,0,41.82617,69.63867,8.002,8.002,0,0,1,34.64355,74.10547ZM228.52734,62.56836a112.28362,112.28362,0,0,0-40.82421-45.34473,7.9996,7.9996,0,1,0-8.54,13.5293,96.29849,96.29849,0,0,1,35.01074,38.88574,8.0002,8.0002,0,1,0,14.35351-7.07031Zm-7.71289,113.37109A15.99808,15.99808,0,0,1,207.0166,200H168a40,40,0,0,1-80,0H48.9834a15.99886,15.99886,0,0,1-13.79688-24.06445C41.124,165.7207,48.20313,146.33594,48.20313,112a79.89888,79.89888,0,0,1,79.79492-80c.2041,0,.40625.001.61035.002A79.70738,79.70738,0,0,1,207.80469,112C207.80469,146.33789,214.87988,165.72363,220.81445,175.93945ZM152,200H104a24,24,0,0,0,48,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.8bff8bce6db391f3468ccd954c0e745b.svg";
export { ForwardRef as ReactComponent };